export const AwscChatMessageStatus = {
  Scheduled: 'SCHEDULED',
  Sent: 'SENT',
  Success: 'SUCCESS',
};
